export const errorHandler = (error) => {
    if (!error.errors) return error.message

    // eslint-disable-next-line no-unused-vars
    return Object.entries(error.errors).reduce((acc, [_, value]) => {
        acc += `${value} \n`
        return acc
    }, '')
}
